import { apiDelete, apiGet, apiPost, apiPut } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showSecondaryLoader } from 'actions/notificationActions';
import { browserHistory } from 'react-router';

import * as notifications from './notificationActions';

export function reportRouter(customizationDetails, asyncMode = false) {
  browserHistory.push(
    `/companies/generate_report?report_type=${customizationDetails.report_type}&async_mode=${asyncMode}`
  );
  if (asyncMode) {
    // skip first fetch
    return dispatch => ({});
  }
  return dispatch => {
    dispatch(showSecondaryLoader(true));
    dispatch(reportGenerator(customizationDetails));
  };
}

export function reportGenerator(customizationDetails) {
  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/insights/${customizationDetails.report_type}`,
        customizationDetails
      )
        .done(response => {
          dispatch(showSecondaryLoader(false));
          dispatch(
            saveReport(
              response.report_details,
              response.date_range.start_date,
              response.date_range.end_date,
              customizationDetails.report_type,
              response.property_ids
            )
          );
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          dispatch(showSecondaryLoader(false));
          console.error(textStatus);
        }),
    });
  };
}

export function postReport(customizationDetails) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/insights`, customizationDetails)
        .done(response => {
          dispatch(showSecondaryLoader(true));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          dispatch(showSecondaryLoader(false));
          console.error(textStatus);
        }),
    });
  };
}

export function getReport(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/insights/${uuid}`)
        .done(response => {
          if (!response) {
            dispatch(notifications.showFailure('unableToRetrieveReport'));
            dispatch(showSecondaryLoader(false));
            return;
          }

          if (response.status === 'failed') {
            dispatch(notifications.showFailure('unableToRetrieveReport'));
            dispatch(showSecondaryLoader(false));
            return;
          }

          if (response.status !== 'completed') {
            return;
          }

          dispatch(showSecondaryLoader(false));
          dispatch(
            saveReport(
              response.report_details,
              response.date_range.start_date,
              response.date_range.end_date,
              response.report_type,
              response.property_ids
            )
          );
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          dispatch(showSecondaryLoader(false));
          console.error(textStatus);
        }),
    });
  };
}

function saveReport(data, startDate, endDate, reportType, propertyIds) {
  return {
    type: 'INSIGHTS::SAVE_REPORT',
    reportData: data,
    startDate,
    endDate,
    reportType,
    propertyIds,
  };
}

export function clearReport() {
  return dispatch => {
    dispatch({
      type: 'INSIGHTS::SAVE_REPORT',
      reportData: [],
      startDate: null,
      endDate: null,
      reportType: null,
      propertyIds: [],
    });
  };
}

// WORKFLOWS

function workflowPayload(formData, workflowID) {
  if (workflowID) {
    return apiPut(Auth.getApiUrl() + `/landlords/workflows/${workflowID}`, formData);
  } else {
    return apiPost(Auth.getApiUrl() + '/landlords/workflows', formData);
  }
}

export function createOrUpdateWorkflow(formData) {
  if (formData['properties']) {
    formData['property_ids'] = formData['properties'].map(property => property.value);
  }

  let verbiage = 'Created';
  const workflowID = formData['id'];
  if (workflowID && workflowID !== undefined) {
    verbiage = 'Updated';
  }

  return dispatch => {
    return dispatch({
      payload: workflowPayload(formData, workflowID)
        .done(response => {
          dispatch(notifications.showSuccess(`Workflow successfully ${verbiage}`));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getWorkflows() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/workflows')
        .done(response => {
          dispatch(saveWorkflow(response.workflows));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

function saveWorkflow(workflows) {
  return {
    type: 'INSIGHTS::SAVE_WORKFLOWS',
    workflows,
  };
}

export function deleteWorkflow(workflowId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/workflows/${workflowId}`)
        .done(() => {
          return dispatch(notifications.showSuccess('workflowSuccessfullyDeleted'));
        })
        .catch((error, textStatus) => {
          console.error(textStatus);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function authenticateInsightsDashboard(dashboardId) {
  return dispatch => {
    return dispatch({
      type: 'INSIGHTS::AUTHENTICATE_INSIGHTS',
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/insights/auth/${dashboardId}`
      ).catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('Could not get credentials', error);
        return false;
      }),
    });
  };
}

export function fetchInsightDashboards() {
  return dispatch => {
    return dispatch({
      type: 'INSIGHTS::FETCH_INSIGHT_DASHBOARDS',
      payload: apiGet(Auth.getApiUrl() + `/landlords/insights/dashboards`).catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('Could not get dashboards', error);
        return false;
      }),
    });
  };
}
